export default "__VITE_ASSET__9fe6c7fb__"